/** CoStar.Api.SuiteResults.DemographicResults.DemographicsCategoryType */
export var DemographicsCategoryType;
(function (DemographicsCategoryType) {
    DemographicsCategoryType[DemographicsCategoryType["None"] = 0] = "None";
    DemographicsCategoryType[DemographicsCategoryType["Age"] = 1] = "Age";
    DemographicsCategoryType[DemographicsCategoryType["ConsumerSpending"] = 2] = "ConsumerSpending";
    DemographicsCategoryType[DemographicsCategoryType["DaytimeEmployment"] = 3] = "DaytimeEmployment";
    DemographicsCategoryType[DemographicsCategoryType["Families"] = 4] = "Families";
    DemographicsCategoryType[DemographicsCategoryType["Householders"] = 5] = "Householders";
    DemographicsCategoryType[DemographicsCategoryType["Households"] = 6] = "Households";
    DemographicsCategoryType[DemographicsCategoryType["HousingUnit"] = 7] = "HousingUnit";
    DemographicsCategoryType[DemographicsCategoryType["HousingValue"] = 8] = "HousingValue";
    DemographicsCategoryType[DemographicsCategoryType["Income"] = 9] = "Income";
    DemographicsCategoryType[DemographicsCategoryType["Occupation"] = 10] = "Occupation";
    DemographicsCategoryType[DemographicsCategoryType["Population"] = 11] = "Population";
    DemographicsCategoryType[DemographicsCategoryType["Travel"] = 12] = "Travel";
})(DemographicsCategoryType || (DemographicsCategoryType = {}));
